/**
 * Convert snake_case Strings to Title Case Strings
 * @param {String} str - The snake_case string to convert
 * @returns {String} The title case string
 */
export function titleCaseFromSnakeCase(str) {
  return str
    .split('_') // split on underscores
    .filter((s) => s) // remove empty strings
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1)) // capitalize first letter
    .join(' ') // join string with spaces
}
